import { render, staticRenderFns } from "./TriggerRS.vue?vue&type=template&id=54e23a89&scoped=true&"
import script from "./TriggerRS.vue?vue&type=script&lang=js&"
export * from "./TriggerRS.vue?vue&type=script&lang=js&"
import style0 from "./TriggerRS.vue?vue&type=style&index=0&id=54e23a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e23a89",
  null
  
)

export default component.exports